import { useEffect, useState } from "react";

const useComponentSize = (ref: any, deps?: any) => {
    const [size, setSize] = useState({ width: 0, height: 0 });
    useEffect(() => {
        setSize({ width: ref?.current?.scrollWidth ?? 0, height: ref?.current?.scrollHeight ?? 0 });
    }, [ref, deps]);
    return size;
};

export default useComponentSize;
